import React, { useReducer, useContext, useCallback } from 'react';
import ThemeReducer from './themeReducer';
import ThemeContext from './themeContext';
import ReportContext from '../report/reportContext';
import AuthContext from '../auth/AuthContext';
import axios from '../../components/Auth/Components/AxiosConfig';
import MainContext from '../main/MainContext';

// TODO update
const defaultTheme = {
  main: '#000000',
  secondary: '#11406F',
  graph: ['#A85658', '#475b84', '#FF7F0E', '#2CA02C', '#9467BD'],
  name: 'Arima Default',
  background: '#F9FCFF',
  //   background: '#fbfcfd',
  //   font: 'Karla',
  font: 'Rubik',
  fontColor: 'black',
  arimaLogo: { path: 'arima-wordmark-white.png' },
};

function ThemeState(props) {
  const reportContext = useContext(ReportContext);
  const authContext = useContext(AuthContext);
  const mainContext = useContext(MainContext);

  const initialState = {
    currentTheme: defaultTheme,
    themes: {},
    reportTheme: {
      main: '#000000',
      secondary: '#11406F',
      graph: ['#A85658', '#475b84', '#FF7F0E', '#2CA02C', '#9467BD'],
    },
    default: defaultTheme,
    palette: {
      //   primary: ['#04223F', '#4F6479', '#81909F', '#CDD3D9'],
      //   secondary: ['#2E3192', '#6D6FB3', '#9698C8', '#D5D6E9'],
      //   tertiary: ['#0083C9', '#4DA8D9', '#80C1E4', '#CCE6F4'],
      //   quarternary: ['#49BD99', '#80D1B8', '#A4DECC', '#DBF2EB'],
      //   quinary: ['#AFD245', '#C7DF7D', '#D7E8A2', '#EFF6DA'],
      primary: ['#0A7BB8', '#4DA8D9', '#80C1E4', '#CCE6F4'],
      secondary: ['#49BD99', '#80D1B8', '#A4DECC', '#DBF2EB'],
      tertiary: ['#2E3192', '#6D6FB3', '#9698C8', '#D5D6E9'],
      text: ['#04223F', '#4F6479', '#81909F', '#CDD3D9'],
      neutral: [
        '#F9FCFF',
        '#F7F9FA',
        '#EAEFF3',
        '#DDE9EF',
        '#CCE6F4',
        '#CDD3D9',
      ],
      semantic: [
        '#AFD245',
        '#EE6363',
        '#FFEF64',
        '#F50057',
        '#EFF6DA',
        '#FFE3E3',
        '#FFFCE1',
      ],
    },
  };
  const [state, dispatch] = useReducer(ThemeReducer, initialState);

  const changeTheme = (theme) => {
    // window.localStorage.setItem('theme', JSON.stringify(theme));
    dispatch({
      type: 'SWITCH',
      payload: theme === 'defaultTheme' || !theme ? defaultTheme : theme,
    });
  };

  const saveReportTheme = async (theme, reportid) => {
    try {
      const token = await authContext.getIdToken();
      await axios(token).post('/save_report_theme', {
        theme: theme === 'defaultTheme' ? defaultTheme : theme,
        reportid: reportid,
      });
      reportContext.getAllReports();
    } catch (err) {
      mainContext.handleError(err);
    }
  };

  const getCustomThemes = useCallback(async () => {
    try {
      const token = await authContext.getIdToken();
      const res = await axios(token).get('/get_custom_themes');
      let custom = {};
      res.data.forEach((m) => {
        custom = { ...custom, [m.id]: m };
      });
      dispatch({ type: 'SET_CUSTOM', payload: custom });
    } catch (err) {
      mainContext.handleError(err);
    }
  }, [authContext]); // eslint-disable-line react-hooks/exhaustive-deps

  const setReportTheme = useCallback((theme) => {
    changeTheme(
      theme ? theme : JSON.parse(window.localStorage.getItem('theme'))
    );
  }, []);

  const saveTheme = async (theme, themeid) => {
    try {
      const token = await authContext.getIdToken();
      const res = await axios(token).post('/save_theme', {
        theme: theme,
        themeid: themeid,
      });
      getCustomThemes();
      return res;
    } catch (err) {
      mainContext.handleError(err);
    }
  };

  const uploadLogo = async (formData) => {
    try {
      const token = await authContext.getIdToken();
      await axios(token).post('/upload_logo', formData);
    } catch (err) {
      mainContext.handleError(err);
    }
  };

  const deteleTheme = async (deleteKey) => {
    try {
      const token = await authContext.getIdToken();
      await axios(token).post('/delete_theme', { deleteKey: deleteKey });
      getCustomThemes();
    } catch (err) {
      mainContext.handleError(err);
    }
  };

  return (
    <ThemeContext.Provider
      value={{
        currentTheme: state.currentTheme,
        themes: state.themes,
        reportTheme: state.reportTheme,
        default: state.default,
        palette: state.palette,
        changeTheme,
        saveReportTheme,
        getCustomThemes,
        setReportTheme,
        saveTheme,
        uploadLogo,
        deteleTheme,
      }}
    >
      {props.children}
    </ThemeContext.Provider>
  );
}

export default ThemeState;
